# A Generic control that can be extended to provide grids
# of buttons in multiple control boxes. This is the basis for
# the L.Control.MfDraw tools
class L.Control.MfButtonGrid extends L.Control
    options:
        position: 'topleft'
        toolbars: []

    # the options.toolbars array can contain entries like this:
    ###
    toolbars: [
        { # Box/Group
            rows: [
                [ # Row
                    # Each object here defines a button / column in the row

                    # data name, symbol, toggle
                    { name: 'draw-poly-add', html: '<i class="drawicon-poly-green"></i>', toggle: true},
                ]
            ]
        },
        { # A second grid of buttons
            rows: []
        }
    ]
    ###
    constructor: () ->
        L.Control.MfButtonGrid.include(L.Mixin.Events)
        super()

    onAdd: (map) ->
        @callbacks  = {}
        @buttons    = {}

        @outerMost = L.DomUtil.create 'div', ''
        @outer = L.DomUtil.create 'div', '', @outerMost
        @outerTooltips = L.DomUtil.create 'div', '', @outerMost

        self = this
        @_map = map

        @createTooltipButtons(self)

        for tb in @options.toolbars
            control_cls = 'leaflet-control-buttongrid'
            container = L.DomUtil.create 'div', "#{control_cls} leaflet-bar", @outer

            if tb.style?
                $(container).css tb.style

            # iterate over the rows for the toolbar, adding them...
            for v in tb.rows
                row = @_addRow container

                # add each button in the row
                for btn in v
                    txt         = btn.html ? btn.name
                    data_name    = btn.name

                    @callbacks[data_name] = []

                    nbtn = L.DomUtil.create 'a', "clickable #{data_name} pull-left", row
                    nbtn.innerHTML = "#{txt}"

                    $(nbtn).css btn.style if btn.style?

                    $(nbtn).data 'drawName', data_name

                    # track the button we created as associated to the drawName it has
                    @buttons[data_name] = $(nbtn)

                    $(nbtn).on 'mouseover', (e) =>
                        @disableMapInteraction()

                    $(nbtn).on 'mouseleave', (e) =>
                        @enableMapInteraction()

                    # Handle click events. If the button is disabled, don't fire click events
                    $(nbtn).on 'click', (e) ->
                        e.preventDefault()
                        #L.DomEvent.preventDefault(e.originalEvent)
                        if $(e.currentTarget).hasClass 'leaflet-buttongrid-disabled'
                            return

                        self.handleClick $(e.currentTarget).data('drawName'), e
                        return false

                    # If the button is a toggle, add the base toggle handler
                    if btn.toggle? and btn.toggle
                        @addCallback data_name, (e, drawname) ->
                            self.toggleButton drawname
                    else
                        @addCallback data_name, (e, drawname) ->
                            self.toggleButton drawname, false

        @positionTooltipButtons()
        @registerTooltipActions()

        return @outerMost

    disableMapInteraction: () =>
        App.map.touchZoom.disable()
        App.map.doubleClickZoom.disable()
        App.map.scrollWheelZoom.disable()

    enableMapInteraction: () =>
        App.map.touchZoom.enable()
        App.map.doubleClickZoom.enable()
        App.map.scrollWheelZoom.enable()

    toggleButton: (btn, select = true) =>
        @deselectAllButtons()
        if select
            @selectBtn btn

    getButton: (btn) ->
        return @buttons[btn]

    selectBtn: (btn) ->
        button = @buttons[btn]
        button?.addClass 'leaflet-buttongrid-active'

        if btn is 'draw-poly-add' or btn is 'draw-poly-sub'
            # always use the add button as a reference so this button will be placed in the same position
            addButton = @buttons['draw-poly-add']
            @positionTooltipButtonsPolygon(addButton)

        if btn is 'draw-rect-add' or btn is 'draw-rect-sub'
            # always use the add button as a reference so this button will be placed in the same position
            addButton = @buttons['draw-rect-add']
            @positionTooltipButtonsRectangle(addButton)


        if btn is 'draw-circle-add' or btn is 'draw-circle-sub'
            # always use the add button as a reference so this button will be placed in the same position
            addButton = @buttons['draw-circle-add']
            @positionTooltipButtonsCircle(addButton)


    deselectBtn: (btn) ->
        button = @buttons[btn]
        button?.removeClass 'leaflet-buttongrid-active'

    deselectAllButtons: () ->
        self = this
        for k of @buttons
            @deselectBtn k

        # when we deselect all buttons, we should also hide all tooltip buttons
        $(@finishButton).css({
            visibility: 'hidden',
        })
        $(@deletePointButton).css({
            visibility: 'hidden',
        })
        $(@cancelButton).css({
            visibility: 'hidden',
        })

    disableBtn: (btn) ->
        btns = @_parseButtonSelector btn
        for i in btns
            button = @buttons[i]
            @deselectBtn i
            button?.addClass 'leaflet-buttongrid-disabled'


    enableBtn: (btn) ->
        btns = @_parseButtonSelector btn
        for i in btns
            button = @buttons[i]
            button?.removeClass 'leaflet-buttongrid-disabled'


    # Enables fancy selectors like "*" (all buttons) and
    # "draw-poly-add,draw-rect-add" (both 'draw-poly-add' and 'draw-rect-add' buttons)
    _parseButtonSelector: (sel) ->
        result = []
        if sel is '*'
            for k, v of @buttons when k isnt 'draw-undo'
                result.push k
        else
            multi = sel.split(',')

            for i in multi
                result.push i

        return result


    handleClick: (name, e) =>
        for i in @callbacks[name]
            i(e, name, @outer)

    addCallback: (data_name, cb) ->
        # add a blanket callback (useful for setting up toggles and other behavior)
        btn  = @_parseButtonSelector data_name

        for i in btn
            @callbacks[i]?.push cb


        return cb

    removeCallback: (data_name, cb) ->
        ind = @callbacks[data_name]?.indexOf(cb)
        if ind isnt -1
            @callbacks[data_name]?.splice ind, 1

    _addRow: (container) ->
        row = L.DomUtil.create 'div', 'leaflet-buttongrid-row drawing-tools-layer', container

        return row

    disableTooltipButton: (button) =>
        if @noTooltipButtons
            return

        $(button).find('a').attr('disabled', true)

    enableTooltipButton: (button) =>
        if @noTooltipButtons
            return

        $(button).find('a').attr('disabled', false)

    registerTooltipActions: () ->
        if @noTooltipButtons
            return

        $(@finishButton).on('click', (e) =>
            # when finish is clicked, we drop a point while clicking the finish buttton
            # the code below removes that extra point and completes the shape
            @current_tool.h._markers.pop().remove()
            @current_tool.h._poly._latlngs.pop()
            @current_tool.h._poly.redraw()
            # dont handle click if disabled
            return if @tooltipButtonIsDisabled(@finishButton)

            @current_tool.h._finishShape()
            @fire('mfdraw:poly-complete')
        )

        $(@deletePointButton).on('click', (e) =>
            # dont handle click if disabled
            return if @tooltipButtonIsDisabled(@deletePointButton)

            # if we are deleting the last point then reset the tool
            if @current_tool.h._markers.length is 1
                @current_tool.disable()
                @_drawPolygon()
            else
                @current_tool.h.deleteLastVertex()

                @current_tool.h._markers.pop().remove()
                @current_tool.h._poly._latlngs.pop()
                @current_tool.h._poly.redraw()

            # disable the finish button if we have less than three markers
            if @current_tool.h._markers?.length < 3
                @disableTooltipButton(@finishButton)
        )

        $(@cancelButton).on('click', (e) =>
            @current_tool.disable()
            @deselectAllButtons()
        )

    positionTooltipButtons: () ->
        if @noTooltipButtons
            return

        $(@outerTooltips).css({
            position: 'absolute'
            top: $(@outer).position().top + 'px'
            left: ($(@outer).position().left + 45) + 'px'
        })

        $(@finishButton).css({
            visibility: 'hidden',
        })

        $(@deletePointButton).css({
            visibility: 'hidden',
            position: 'absolute'
            top: $(@finishButton).position().top + 'px'
            left: ($(@finishButton).position().left + 67) + 'px'
        })

        $(@cancelButton).css({
            visibility: 'hidden',
            position: 'absolute'
            top: '0px'
            left: ($(@deletePointButton).position().left + 167) + 'px'
        })

    createTooltipButtons: () ->
        if @noTooltipButtons
            return
        # create tooltip container
        tooltipContainer = L.DomUtil.create 'ul', "pull-right tooltip-buttons-container", @outerTooltips

        # create the finish button
        @finishButton = L.DomUtil.create 'li', 'tooltip-buttons', tooltipContainer
        innerFinishButton = L.DomUtil.create 'a', 'pull-left clickable tooltip-button tooltip-button-left', @finishButton
        innerFinishButton.title = 'Finish'
        innerFinishButton.innerHTML = 'Finish'

        # create the delete last point button
        @deletePointButton = L.DomUtil.create 'li', 'tooltip-buttons', tooltipContainer
        innerDeletePointButton = L.DomUtil.create 'a', 'pull-left clickable tooltip-button tooltip-button-middle', @deletePointButton
        innerDeletePointButton.title = 'Delete Last Point'
        innerDeletePointButton.innerHTML = 'Delete Last Point'

        # create the cancel button
        @cancelButton = L.DomUtil.create 'li', 'tooltip-buttons', tooltipContainer
        innerCancelButton = L.DomUtil.create 'a', 'pull-left clickable tooltip-button tooltip-button-right tooltip-button-end', @cancelButton
        innerCancelButton.title = 'Cancel'
        innerCancelButton.innerHTML = 'Cancel'

        # allow multiple clicks on the tooltip buttons without zooming the map
        $(@deletePointButton).on 'mouseover', (e) =>
            @disableMapInteraction()
        $(@deletePointButton).on 'mouseleave', (e) =>
            @enableMapInteraction()
        $(@finishButton).on 'mouseover', (e) =>
            @disableMapInteraction()
        $(@finishButton).on 'mouseleave', (e) =>
            @enableMapInteraction()
        $(@cancelButton).on 'mouseover', (e) =>
            @disableMapInteraction()
        $(@cancelButton).on 'mouseleave', (e) =>
            @enableMapInteraction()


    tooltipButtonIsDisabled: (button) =>
        return $(button).find('a').is('[disabled=disabled]')

    positionTooltipButtonsPolygon: (addButton) ->
        if @noTooltipButtons
            return

        $(@cancelButton).removeClass('tooltip-button-left')


        $(@finishButton).css({
            visibility: 'visible',
        })
        $(@deletePointButton).css({
            visibility: 'visible',
        })

        $(@cancelButton).css({
            visibility: 'visible'
            position: 'absolute'
            top: '0px'
            left: ($(addButton).position().left + 167) + 'px'
        })

        $(@cancelButton).find('a').removeClass('tooltip-button-left')
        $(@cancelButton).find('a').addClass('tooltip-button-end')

    positionTooltipButtonsRectangle: (addButton) ->
        if @noTooltipButtons
            return

        $(@cancelButton).addClass('tooltip-button-left')
        $(@cancelButton).css({
            visibility: 'visible',
        })

        $(@cancelButton).css({
            position: 'absolute'
            top: $(addButton).position().top + 31 + 'px'
            left: ($(addButton).position().left + 25) + 'px'
        })

        $(@cancelButton).find('a').addClass('tooltip-button-left')
        $(@cancelButton).find('a').removeClass('tooltip-button-end')

    positionTooltipButtonsCircle: (addButton) ->
        if @noTooltipButtons
            return

        $(@cancelButton).css({
            visibility: 'visible',
        })

        $(@cancelButton).css({
            position: 'absolute'
            top: $(addButton).position().top + 62 + 'px'
            left: ($(addButton).position().left + 25) + 'px'
        })

        $(@cancelButton).find('a').addClass('tooltip-button-left')
        $(@cancelButton).find('a').removeClass('tooltip-button-end')
